/* eslint-disable simple-import-sort/imports */

import React from 'react';
import ReactGA from 'react-ga4';
import { connect } from 'react-redux';
import cn from 'classnames';
import Navigation from 'invite/components/Navigation.component';
import { withTheme } from 'providers/Theme.provider';
import { formatYearHourMinuteFull } from 'utils/date/format.util';

import IMG_CHECK from 'assets/images/icons/check-circle-purple.svg';
import DELAY from 'constants/delay.const';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromEntriesToObject from 'utils/converters/object/fromEntriesToObject.util';
import delayed from 'utils/functions/delayed.util';
import modifyUrl from 'utils/links/modifyUrl.util';
import asObject from 'utils/objects/asObject.util';

import { clearSelectedAppointmentTime, getSalonDetails, setPageVisited } from 'booking/actions';
import SummaryComponent from 'booking/summary/Summary';
import { fbPixelTracking } from 'lib/utils';

import CN from './BookingConfirmedSummary.module.scss';

export class BookingConfirmedSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shouldMount: false,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    if (this.props.selectedServices.length === 0) {
      this.props.history.push(`/salon/${this.props.match.params.id}`);
      return;
    }

    if (!this.props.salonDetails.id) {
      this.props.getSalonDetails(parseInt(this.props.match.params.id, 10));
    }

    this.setState({ shouldMount: true });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.setPageVisited('bookingConfirmed');
    fbPixelTracking(this.props.salonDetails.fb_details.fb_pixel_id, 'Schedule');
    ReactGA.event({
      category: 'Page View',
      action: ' Made a booking',
      label: 'Reached booking confirmation page',
    });

    const searchParams = new URLSearchParams(this.props.location.search);
    const incomingParams = fromEntriesToObject(searchParams.entries());

    if (!incomingParams.gclid && this.props.gclid) {
      incomingParams.gclid = this.props.gclid;
    }

    delayed(DELAY.attention, () => {
      this.handleRedirect(incomingParams);
    });
  }

  handleRedirect = incomingParams => {
    const safeParams = asObject(incomingParams);
    const { selectedAppointmentTime, billing, selectedServices, selectedStylists, salonDetails } = this.props;
    const queryParams = new URLSearchParams(safeParams);

    const { gclid } = safeParams;
    if (gclid) {
      queryParams.set('gclid', gclid);
    }

    if (selectedAppointmentTime && selectedAppointmentTime.isValid) {
      const bookingDate = formatYearHourMinuteFull(selectedAppointmentTime);
      queryParams.set('booking_date_time', bookingDate);
    }

    if (billing && billing.appointment_cost) {
      queryParams.set('booking_value', billing.appointment_cost);
    }

    if (billing && billing.pay_today) {
      queryParams.set('deposit_paid', billing.pay_today);
    }

    if (selectedServices && selectedServices.length) {
      const servicesAndStylists = selectedServices.map(service => {
        const stylist = selectedStylists[service.id];
        const stylistName = stylist ? stylist.stylist_name : '';
        return `${service.name} , ${stylistName}`;
      });

      queryParams.set('services', servicesAndStylists.join('|'));
    }

    if (salonDetails && fromAnyToBool(salonDetails.redirect_after_ncob_booking) && salonDetails.salon_website_link) {
      const fullRedirectUrl = modifyUrl({
        url: salonDetails.salon_website_link,
        addParams: fromEntriesToObject(queryParams.entries()),
      });
      window.location.href = fullRedirectUrl;
    }
  };

  render() {
    const { isDarkMode, isNeutralMode, salonDetails } = this.props;
    const { ncob_deposit_settings: ncobDeposit, needs_card: needsCard } = salonDetails;

    return (
      <div
        data-bem="BookingConfirmedSummary"
        className={cn({
          [CN.component]: true,
          [CN.dark]: isDarkMode,
          [CN.neutral]: isNeutralMode,
        })}
      >
        <div className={CN.wrapper}>
          <Navigation match={this.props.match} />

          <div className={CN.statusIcon}>
            <img src={IMG_CHECK} alt="successful icon" />
          </div>

          <div className={CN.title}>
            {fromAnyToBool(this.props.isWaitList) ? (
              <div>Awesome, you are on the waitlist!</div>
            ) : (
              <div>
                {ncobDeposit !== 'null' && needsCard ? (
                  <div>
                    Payment successful!
                    <br />
                    Booking has been confirmed
                  </div>
                ) : (
                  <div>Booking has been confirmed!</div>
                )}
              </div>
            )}
          </div>

          {this.state.shouldMount && (
            <>
              <SummaryComponent isAppointmentConfirmed salonDetails={salonDetails} history={this.props.history} />
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { booking, billing } = state;
  const {
    salonDetails,
    selectedServices,
    selectedStylists,
    selectedAppointmentTime,
    bookingResponse,
    availablePatchDays,
    firstAvailablePatchDate,
    referrerInfo,
    isWaitList,
    gclid,
  } = booking;
  return {
    salonDetails,
    selectedServices,
    selectedStylists,
    selectedAppointmentTime,
    availablePatchDays,
    firstAvailablePatchDate,
    bookingResponse,
    referrerInfo,
    isWaitList,
    appointment_id: bookingResponse ? bookingResponse.appointment_id : null,
    billing,
    gclid,
  };
};

const mapDispatchToProps = dispatch => ({
  getSalonDetails(salonId) {
    dispatch(getSalonDetails(salonId));
  },
  clearSelectedAppointmentTime() {
    dispatch(clearSelectedAppointmentTime());
  },
  setPageVisited(page) {
    dispatch(setPageVisited(page));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withTheme()(BookingConfirmedSummary));
